import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import AuthLayout from '../components/AuthLayout';
import AuthError from '../components/AuthError';
import Field from '../components/Field';
import { useAuth } from '../auth/AuthContext';
import { emailRules } from '../lib/validation';

function Register() {
  const navigate = useNavigate();
  const { register: registerUser } = useAuth();
  const [serverError, setServerError] = useState('');
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { name: '', email: '', password: '' } });

  const onSubmit = async ({ name, email, password }) => {
    setServerError('');
    try {
      await registerUser(name, email, password);
      navigate('/');
    } catch (error) {
      setServerError(error.message || 'Registration failed');
    }
  };

  return (
    <AuthLayout
      title="Create an account"
      description="Start building with Mini Notion"
      footerText="Already have an account?"
      footerLinkLabel="Login"
      footerLinkTo="/login"
    >
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="space-y-4 px-6 pb-4">
          <AuthError message={serverError} />

          <Field name="name" label="Name" error={errors.name?.message}>
            <Input
              type="text"
              placeholder="Your name"
              {...register('name', { required: 'Name is required' })}
            />
          </Field>

          <Field name="email" label="Email" error={errors.email?.message}>
            <Input
              type="email"
              placeholder="you@example.com"
              {...register('email', emailRules)}
            />
          </Field>

          <Field name="password" label="Password" error={errors.password?.message}>
            <Input
              type="password"
              placeholder="Min 6 characters"
              {...register('password', {
                required: 'Password is required',
                minLength: { value: 6, message: 'Password must be at least 6 characters' },
              })}
            />
          </Field>

          <Button type="submit" className="w-full" disabled={isSubmitting}>
            {isSubmitting ? 'Registering...' : 'Register'}
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
}

export default Register;
